module.exports = __webpack_public_path__ + "img/img-fachai.179a4c67.png";